import React from 'react';
import Input from '@/components/Input.jsx';

const WizardInput = React.forwardRef(({ ...props }, ref) => {
  return <Input size="lg" {...props} ref={ref} />;
});

WizardInput.displayName = 'WizardInput';

export default WizardInput;
